//-------------------------------------------------------------------------------------------------- Imports
import { Button, Card, Typography, Divider } from "antd";
import { StyleSheet } from "../StyleSheet";
import { CheckCircleFilled, CloseCircleFilled, InfoCircleFilled } from "@ant-design/icons";
import TextSplitter from "./TextSplitter";
import { useSelector } from "react-redux";
import { getAlertData } from "../stores/slices/alertSlice";
import { images } from "../routes/ImageRoutes";
const { Text } = Typography;


//-------------------------------------------------------------------------------------------------- Component
const AlertModal = () => {
    const {
        show, type, title, subtitle, message, paymentData, onFinalize, extraComponents, isReceiptPayment
    } = useSelector(getAlertData);
    const backgroundStyle = (type === "SUCCESS") ? (styles.successBGColor) : (
        (type === "INFO") ? (styles.infoBGColor) : (styles.errorBGColor)
    );
    const colorStyle = (type === "SUCCESS") ? (styles.successColor) : (
        (type === "INFO") ? (styles.infoColor) : (styles.errorColor)
    );
    const iconType = (type === "SUCCESS") ? (
        <CheckCircleFilled style={styles.iconStyle} />
    ) : ((type === "INFO") ? (
        <InfoCircleFilled style={styles.iconStyle} />
    ) : (
        <CloseCircleFilled style={styles.iconStyle} />
    ));

    return ((show) ? (
        <>
            {
                isReceiptPayment ?
                    <div style={styles.mainContainer}>
                        <Card style={styles.cardStyle} bodyStyle={styles.cardBody}>
                            <div style={styles.divRoot}>
                                <img
                                    src={images.megaLogoMR}
                                    alt="mega-logo"
                                    style={styles.imageLogo}
                                />
                            </div>
                            <h3 style={styles.titlePayment}>
                                TOTAL PAGADO: ${paymentData?.amount}
                            </h3>
                            <Text style={styles.titleDataPayment}>
                                {"CONCEPTO: "}
                                <Text style={styles.descriptionDataPayment}>
                                    {paymentData?.concept}
                                </Text>
                            </Text>
                            <Text style={styles.titleDataPayment}>
                                {"FECHA: "}
                                <Text style={styles.descriptionDataPayment}>
                                    {paymentData?.date}
                                </Text>
                            </Text>
                            <Text style={styles.titleDataPayment}>
                                {"HORA: "}
                                <Text style={styles.descriptionDataPayment}>
                                    {paymentData?.time}
                                </Text>
                            </Text>
                            <Divider style={styles.lineDivider} />
                            <Text style={styles.descriptionDataPayment}>
                                {"CON CARGO A:"}
                            </Text>
                            <Text style={styles.titleDataPayment}>
                                {paymentData?.name}
                            </Text>
                            <Text style={styles.titleDataPayment}>
                                {"CONTRATO: "}
                                <Text style={styles.descriptionDataPayment}>
                                    {paymentData?.client}
                                </Text>
                            </Text>
                            <Text style={{ ...styles.titleDataPayment, marginTop: 30 }}>
                                {"MEDIO DE PAGO: "}
                            </Text>
                            <Text style={styles.descriptionDataPayment}>
                                {paymentData?.idTransaction ? "PAYPAL" : "TARJETA DÉBITO/CRÉDITO"}
                            </Text>
                            <Text style={{ ...styles.titleDataPayment, marginTop: 30 }}>
                                {paymentData?.idTransaction ? "ID DE TRANSACCIÓN:" : "TARJETA:"}
                            </Text>
                            <Text style={styles.descriptionDataPayment}>
                                {paymentData?.idTransaction ? paymentData?.idTransaction : paymentData?.card}
                            </Text>
                            <Divider style={styles.lineDivider} />
                            <Text style={styles.timePayment}>
                                Su pago se verá reflejado en un
                            </Text>
                            <Text style={styles.timePayment}>
                                máximo de 24 horas
                            </Text>
                        </Card>
                        <div style={{ ...styles.buttonsContainer, padding: "20px 0px 20px 0px", }}>
                            {
                                extraComponents ?
                                    extraComponents
                                    :
                                    <Button
                                        style={styles.buttonStyle}
                                        onClick={() => { (onFinalize) && onFinalize() }}
                                    >
                                        Finalizar
                                    </Button>
                            }
                        </div>
                    </div >
                    :
                    <div style={styles.mainContainer}>
                        <div style={styles.cardContainer}>
                            <div style={{ ...styles.headerContainer, ...backgroundStyle }}>
                                {iconType}
                            </div>
                            <div style={styles.bodyContainer}>
                                <h2 style={colorStyle}>{title}</h2>
                                {
                                    subtitle ?
                                        <h3 style={{ color: "#000000", margin: 10 }}>
                                            {subtitle}
                                        </h3>
                                        :
                                        null
                                }
                                <TextSplitter style={{ margin: 5 }} text={message} />
                            </div>
                        </div>
                        <div style={styles.buttonsContainer}>
                            {
                                extraComponents ?
                                    extraComponents
                                    :
                                    <Button
                                        style={styles.buttonStyle}
                                        onClick={() => { (onFinalize) && onFinalize() }}
                                    >
                                        Finalizar
                                    </Button>
                            }
                        </div>
                    </div>
            }
        </>
    ) : (
        null
    ));
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        zIndex: 100,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(0 0 0 / 60%)",
    },
    cardContainer: {
        width: 400,
        borderRadius: "15px",
    },
    headerContainer: {
        display: "flex",
        width: "100%",
        height: 150,
        borderRadius: "15px 15px 0px 0px",
        alignItems: "center",
        justifyContent: "center",
    },
    infoBGColor: {
        backgroundColor: "#e8b031",
    },
    successBGColor: {
        backgroundColor: "#0055c2",
    },
    errorBGColor: {
        backgroundColor: "#e00614",
    },
    iconStyle: {
        fontSize: 80,
        color: "#ffffff",
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "40px 20px 40px 20px",
        borderRadius: "0px 0px 15px 15px",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
    },
    buttonsContainer: {
        display: "flex",
        width: 450,
        padding: "40px 0px 40px 0px",
        alignItems: "center",
        justifyContent: "center",
    },
    buttonStyle: {
        height: 40,
        fontSize: 18,
        fontWeight: 600,
        padding: "0px 40px 0px 40px",
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    infoColor: {
        margin: 0,
        marginBottom: 20,
        color: "#e8b031",
    },
    successColor: {
        margin: 0,
        marginBottom: 20,
        color: "#0055c2",
    },
    errorColor: {
        margin: 0,
        marginBottom: 20,
        color: "#e00614",
    },
    imageLogo: {
        maxHeight: 40,
        maxWidth: "100%",
        marginTop: 40,
        marginBottom: 15
    },
    divRoot: {
        maxWidth: "100%",
        maxheight: 30
    },
    cardStyle: {
        width: 400,
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
        display: 'flex',
        alignItems: 'center',
    },
    cardBody: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        width: "100%"
    },
    megaTitle: {
        color: "#000000",
        fontSize: "1.2em",
        margin: "5px 0px",
        fontWeight: 600,
    },
    megaAdress: {
        color: "#000000",
        fontSize: "0.9em",
        fontWeight: 500,
    },
    lineDivider: {
        backgroundColor: '#b2b2b2',
        padding: 0.5,
        minWidth: "60%",
        width: "60%"
    },
    titlePayment: {
        color: "#000000",
        fontSize: "1.1em",
        margin: "20px 0px",
        fontWeight: 800,
    },
    titleDataPayment: {
        color: "#000000",
        fontSize: "1em",
        fontWeight: 800,
        lineHeight: 2
    },
    descriptionDataPayment: {
        color: "#000000",
        fontSize: "1em",
        fontWeight: 500,
    },
    timePayment: {
        color: "#000000",
        fontSize: "0.9em",
        fontWeight: 500,
        lineHeight: 1.3
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default AlertModal;